<template>
    <div
        style="display: inline-block;"
    >
        <template v-if="show_open_data">
            <template v-if="app_use_open_data && useOpenData">
                <Opendata :type="type" :openid="openid" :name="name"/>
            </template>
            <template v-else>
                {{name  | userDepartment}}
            </template>
        </template>
    </div>

</template>
<script>
import Opendata from './opendata.vue'
export default {
    data(){
        return {
            show_open_data: false,
            app_use_open_data: false
        }
    },
    computed:{
  
    },
    props: ["type", "openid", "useOpenData","name"],
    components:{
        Opendata
    },
    filters:{
        userDepartment : value => {
            if (!!value) {
                return typeof value == 'string' ? value : value[0].substr(0,8)
            }
        }
    },
    mounted() {
        let Vm = this;
        if(window.show_open_data){
            Vm.app_use_open_data = window.use_open_data;
            Vm.show_open_data = window.show_open_data;
        }else if(!window.wxRecordCallback){
            window.wxRecordCallbackList = [];
            window.wxRecordCallback = function(res){
                let params = res;
                if(typeof params === 'function'){
                    window.wxRecordCallbackList.push(params)
                    return
                }else if(typeof params === 'object'){
                    Vm.app_use_open_data = params.use_open_data;
                    Vm.show_open_data = params.show_open_data;
                    window.wxRecordCallbackList.forEach(item => {
                        if(typeof item === 'function') item(params)
                    });
                    window.wxRecordCallbackList = [];
                }
            }
        }else{
            window.wxRecordCallback(function(params){
                Vm.app_use_open_data = params.use_open_data;
                Vm.show_open_data = params.show_open_data;
            })
        }
    },
};
</script>